import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src", "poster"]
const _hoisted_2 = { class: "bezel" }
const _hoisted_3 = { class: "controller" }
const _hoisted_4 = { class: "icons icons-left" }
const _hoisted_5 = { class: "icon-content" }
const _hoisted_6 = { class: "volume" }
const _hoisted_7 = { class: "icon-content" }
const _hoisted_8 = {
  class: "volume-bar",
  ref: "volumeBarRef"
}
const _hoisted_9 = { class: "time" }
const _hoisted_10 = { class: "ptime" }
const _hoisted_11 = { class: "dtime" }
const _hoisted_12 = { class: "icons icons-right" }
const _hoisted_13 = { class: "speed" }
const _hoisted_14 = { class: "icon speed-icon" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "bar" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconPause = _resolveComponent("IconPause")!
  const _component_IconPlayOne = _resolveComponent("IconPlayOne")!
  const _component_IconVolumeMute = _resolveComponent("IconVolumeMute")!
  const _component_IconVolumeNotice = _resolveComponent("IconVolumeNotice")!
  const _component_IconVolumeSmall = _resolveComponent("IconVolumeSmall")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["video-player", { 'hide-controller': _ctx.hideController }]),
    style: _normalizeStyle({
      width: _ctx.width * _ctx.scale + 'px',
      height: _ctx.height * _ctx.scale + 'px',
      transform: `scale(${1 / _ctx.scale})`,
    }),
    onMousemove: _cache[22] || (_cache[22] = ($event: any) => (_ctx.autoHideController())),
    onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.autoHideController()))
  }, [
    _createElementVNode("div", {
      class: "video-wrap",
      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.toggle()))
    }, [
      _createElementVNode("video", {
        class: "video",
        ref: "videoRef",
        src: _ctx.src,
        poster: _ctx.poster,
        "webkit-playsinline": "",
        playsinline: "",
        onDurationchange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleDurationchange())),
        onTimeupdate: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleTimeupdate())),
        onEnded: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleEnded())),
        onProgress: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleProgress())),
        onPlay: _cache[4] || (_cache[4] = ($event: any) => (_ctx.autoHideController())),
        onPause: _cache[5] || (_cache[5] = ($event: any) => (_ctx.autoHideController())),
        onError: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleError()))
      }, null, 40, _hoisted_1),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", {
          class: _normalizeClass(["bezel-icon", { 'bezel-transition': _ctx.bezelTransition }]),
          onAnimationend: _cache[7] || (_cache[7] = ($event: any) => (_ctx.bezelTransition = false))
        }, [
          (_ctx.paused)
            ? (_openBlock(), _createBlock(_component_IconPause, { key: 0 }))
            : (_openBlock(), _createBlock(_component_IconPlayOne, { key: 1 }))
        ], 34)
      ])
    ]),
    _cache[28] || (_cache[28] = _createElementVNode("div", { class: "controller-mask" }, null, -1)),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: "icon play-icon",
          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.toggle()))
        }, [
          _createElementVNode("span", _hoisted_5, [
            (_ctx.paused)
              ? (_openBlock(), _createBlock(_component_IconPlayOne, { key: 0 }))
              : (_openBlock(), _createBlock(_component_IconPause, { key: 1 }))
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", {
            class: "icon volume-icon",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.toggleVolume()))
          }, [
            _createElementVNode("span", _hoisted_7, [
              (_ctx.volume === 0)
                ? (_openBlock(), _createBlock(_component_IconVolumeMute, { key: 0 }))
                : (_ctx.volume === 1)
                  ? (_openBlock(), _createBlock(_component_IconVolumeNotice, { key: 1 }))
                  : (_openBlock(), _createBlock(_component_IconVolumeSmall, { key: 2 }))
            ])
          ]),
          _createElementVNode("div", {
            class: "volume-bar-wrap",
            onMousedown: _cache[11] || (_cache[11] = $event => _ctx.handleMousedownVolumeBar($event)),
            onTouchstart: _cache[12] || (_cache[12] = $event => _ctx.handleMousedownVolumeBar($event)),
            onClick: _cache[13] || (_cache[13] = $event => _ctx.handleClickVolumeBar($event))
          }, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", {
                class: "volume-bar-inner",
                style: _normalizeStyle({ width: _ctx.volumeBarWidth })
              }, _cache[24] || (_cache[24] = [
                _createElementVNode("span", { class: "thumb" }, null, -1)
              ]), 4)
            ], 512)
          ], 32)
        ]),
        _createElementVNode("span", _hoisted_9, [
          _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.ptime), 1),
          _cache[25] || (_cache[25] = _createTextVNode(" / ")),
          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.dtime), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("span", {
              class: "icon-content",
              onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.speedMenuVisible = !_ctx.speedMenuVisible))
            }, "倍速"),
            (_ctx.speedMenuVisible)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "speed-menu",
                  onMouseleave: _cache[15] || (_cache[15] = ($event: any) => (_ctx.speedMenuVisible = false))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.speedOptions, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["speed-menu-item", { 'active': item.value === _ctx.playbackRate }]),
                      key: item.label,
                      onClick: ($event: any) => (_ctx.speed(item.value))
                    }, _toDisplayString(item.label), 11, _hoisted_15))
                  }), 128))
                ], 32))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", {
          class: "loop",
          onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.toggleLoop()))
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["icon loop-icon", { 'active': _ctx.loop }])
          }, _cache[26] || (_cache[26] = [
            _createElementVNode("span", { class: "icon-content" }, "循环", -1)
          ]), 2)
        ])
      ]),
      _createElementVNode("div", {
        class: "bar-wrap",
        ref: "playBarWrap",
        onMousedown: _cache[17] || (_cache[17] = $event => _ctx.handleMousedownPlayBar($event)),
        onTouchstart: _cache[18] || (_cache[18] = $event => _ctx.handleMousedownPlayBar($event)),
        onMousemove: _cache[19] || (_cache[19] = $event => _ctx.handleMousemovePlayBar($event)),
        onMouseenter: _cache[20] || (_cache[20] = ($event: any) => (_ctx.playBarTimeVisible = true)),
        onMouseleave: _cache[21] || (_cache[21] = ($event: any) => (_ctx.playBarTimeVisible = false))
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["bar-time", { 'hidden': !_ctx.playBarTimeVisible }]),
          style: _normalizeStyle({ left: _ctx.playBarTimeLeft })
        }, _toDisplayString(_ctx.playBarTime), 7),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", {
            class: "loaded",
            style: _normalizeStyle({ width: _ctx.loadedBarWidth })
          }, null, 4),
          _createElementVNode("div", {
            class: "played",
            style: _normalizeStyle({ width: _ctx.playedBarWidth })
          }, _cache[27] || (_cache[27] = [
            _createElementVNode("span", { class: "thumb" }, null, -1)
          ]), 4)
        ])
      ], 544)
    ])
  ], 38))
}